import type { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.js';

const NAV = [
  { to: '/', label: 'Dashboard', perm: 'dashboard.ver' },
  { to: '/crecimiento', label: 'Crecimiento', perm: 'dashboard.ver' },
  { to: '/ingesta', label: 'Ingesta', perm: 'flash.ingestar' },
  { to: '/reportes', label: 'Reportes', perm: 'reporte.exportar' },
  { to: '/tasa', label: 'Tasa BCV', perm: 'dashboard.ver' },
];

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout, can } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-10 border-b border-slate-800 bg-slate-900/80 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-6">
            <span className="font-semibold text-slate-100">Manager-Flash</span>
            <nav className="flex gap-1">
              {NAV.filter((n) => can(n.perm)).map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === '/'}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-1.5 text-sm ${
                      isActive ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-400">
            <span>{user?.nombre ?? user?.email}</span>
            <button
              className="rounded-md border border-slate-700 px-3 py-1.5 hover:bg-slate-800"
              onClick={async () => {
                await logout();
                navigate('/login');
              }}
            >
              Salir
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">{children}</main>
    </div>
  );
}
